import { Box } from "@valenzinsights/core-component";

import React from "react";

interface BackgroundWrapperProps {
	children?: React.ReactNode;
}

export const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({
	children,
}) => {
	const backgroundStyle = {
		position: "fixed",
		top: "70%",
		left: "66%",
		right: 0,
		bottom: 0,
		backgroundImage: `url(${require("../assets/images/PraznaInsightLogo.svg").default})`,
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		zIndex: -1,
	};

	return (
		<Box>
			<Box id="background-provider" sx={backgroundStyle} />
			{children}
		</Box>
	);
};
